import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '@portals/core';

import * as Highcharts from 'highcharts';

@Component({
	selector: 'portals-dashboard-sentiment-pie',
	templateUrl: './sentiment-pie.component.html',
	styleUrls: ['./sentiment-pie.component.scss'],
})
export class SentimentPieComponent extends BaseComponent implements OnInit {
	constructor() {
		super();
	}
	data = [
		{
			name: 'Neutral',
			y: 23,
			color: '#D3D3D3',
		},
		{
			name: 'Positive',
			y: 45,
			color: '#90EE90',
		},
		{
			name: 'Negative',
			y: 32,
			color: 'red',
		},
	];
	opts: Highcharts.Options = {
		chart: {
			type: 'pie',
		},
		title: {
			text: '',
			align: 'left',
		},
		plotOptions: {
			pie: {
				shadow: false,
				center: ['50%', '50%'],
			},
		},
		tooltip: {
			valueSuffix: '%',
		},
		series: [
			{
				name: 'Versions',
				data: this.data,
				size: '80%',
				innerSize: '60%',
				dataLabels: {
					format: '<b>{point.name}:</b> <span style="opacity: 0.5">{y}%</span>',
					filter: {
						property: 'y',
						operator: '>',
						value: 1,
					},
					style: {
						fontWeight: 'normal',
					},
				},
			} as Highcharts.SeriesOptionsType,
		],
	};
	ngOnInit(): void {
		// console.log('');
		Highcharts.chart('pieCont', this.opts);
	}
}
